import { driver } from "driver.js";
import "driver.js/dist/driver.css";
import "./eduDocumentsTour.css";

export function startEduDocumentCreateTour() {
  const steps = [
    {
      popover: {
        title: "Hướng dẫn nhanh",
        description:
          "Form 2 cột: bên trái nhập liệu, bên phải xem kết quả khởi tạo theo thời gian thực.",
        side: "over",
        align: "center",
      },
    },
  ];

  const segments = [
    {
      selector: '[data-tour="edu-doc-create-header"]',
      title: "Header",
      description:
        "Tiêu đề form và chip trạng thái hoàn thiện. Nút lấp lánh mở lại tour.",
      side: "bottom",
    },
    {
      selector: '[data-tour="edu-doc-create-config"]',
      title: "Phân loại",
      description:
        "Chọn môn học và loại tài liệu (bắt buộc). Khóa học tùy chọn nếu dùng chung nhiều khóa.",
      side: "bottom",
    },
    {
      selector: '[data-tour="edu-doc-create-file"]',
      title: "Tệp tài liệu",
      description: "Tải tối đa 10 tệp. Định dạng phụ thuộc loại đã chọn.",
      side: "top",
    },
    {
      selector: '[data-tour="edu-doc-create-preview"]',
      title: "Kết quả khởi tạo",
      description:
        "Cột phải tóm tắt tên, môn, loại, khóa học và tệp — cập nhật ngay khi bạn nhập.",
      side: "left",
    },
    {
      selector: '[data-tour="edu-doc-create-actions"]',
      title: "Lưu",
      description: "Bấm Lưu tài liệu để hoàn tất. Tiến trình upload hiện ở đây.",
      side: "top",
    },
  ];

  for (const seg of segments) {
    const el = document.querySelector(seg.selector);
    if (!el) continue;
    steps.push({
      element: el,
      popover: {
        title: seg.title,
        description: seg.description,
        side: seg.side,
      },
    });
  }

  if (steps.length <= 1) {
    window.alert(
      "Không tìm thấy vùng để chạy hướng dẫn. Hãy mở modal rồi thử lại."
    );
    return;
  }

  const d = driver({
    showProgress: true,
    smoothScroll: true,
    stagePadding: 10,
    stageRadius: 14,
    overlayOpacity: 0.68,
    overlayColor: "#0f172a",
    popoverClass: "edu-documents-tour-popover",
    nextBtnText: "Tiếp",
    prevBtnText: "Trước",
    doneBtnText: "Xong",
    progressText: "Bước {{current}} / {{total}}",
    showButtons: ["next", "previous", "close"],
    steps,
  });

  d.drive();
}
